module.exports = __webpack_public_path__ + "static/media/16b-03_Ncrekonchoe-1-2016-128x95cm-oleo-y-aceite-de-lino-sobre-papel.892e334f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16b/16b-03_Ncrekonchoe-1-2016-128x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 190
// module chunks = 0